<template>
    <div class="view view--social-login">
        <social-login />
    </div>
</template>

<script>
    import socialLogin from '../../components/SocialLogin.vue';

    export default {
        components: {
            socialLogin
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/auth/SocialLogin.vue